import { render, staticRenderFns } from "./answerScriptCollectionList.vue?vue&type=template&id=236c8858&"
import script from "./answerScriptCollectionList.vue?vue&type=script&lang=js&"
export * from "./answerScriptCollectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports